module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-form', {
    model: {
      value: (_vm.isAddValid),
      callback: function($$v) {
        _vm.isAddValid = $$v
      },
      expression: "isAddValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "slider-color": "grey",
      "centered": ""
    },
    model: {
      value: (_vm.currentTab),
      callback: function($$v) {
        _vm.currentTab = $$v
      },
      expression: "currentTab"
    }
  }, [_c('v-tab', {
    key: 1,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Project Info")]), _vm._v(" "), _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Project Delivery")]), _vm._v(" "), _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Images")]), _vm._v(" "), _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Transport")]), _vm._v(" "), _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Additional Details")]), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-0 pb-0"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Include for Tendering"
    },
    model: {
      value: (_vm.projectTendering),
      callback: function($$v) {
        _vm.projectTendering = $$v
      },
      expression: "projectTendering"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Tender Closing Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en"
    },
    model: {
      value: (_vm.projectTenderClosingDate),
      callback: function($$v) {
        _vm.projectTenderClosingDate = $$v
      },
      expression: "projectTenderClosingDate"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Name",
      "rules": _vm.projectNameRules,
      "solo": ""
    },
    model: {
      value: (_vm.projectName),
      callback: function($$v) {
        _vm.projectName = $$v
      },
      expression: "projectName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Code")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Code",
      "solo": ""
    },
    model: {
      value: (_vm.projectCode),
      callback: function($$v) {
        _vm.projectCode = $$v
      },
      expression: "projectCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Reference")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Project Reference",
      "solo": ""
    },
    model: {
      value: (_vm.projectReference),
      callback: function($$v) {
        _vm.projectReference = $$v
      },
      expression: "projectReference"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Status")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectStatusList,
      "rules": _vm.projectStatusRules,
      "label": "Project Status",
      "item-value": "text",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.projectStatus),
      callback: function($$v) {
        _vm.projectStatus = $$v
      },
      expression: "projectStatus"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Project Type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectTypeList,
      "rules": _vm.projectTypeRules,
      "label": "Project Type",
      "item-value": "id",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.projectType),
      callback: function($$v) {
        _vm.projectType = $$v
      },
      expression: "projectType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Professionals")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectSpecifiers,
      "label": "No Specifier Assigned",
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": _vm.fncChangeSpecifierType
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('small', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })]
      }
    }]),
    model: {
      value: (_vm.projectSpecifier),
      callback: function($$v) {
        _vm.projectSpecifier = $$v
      },
      expression: "projectSpecifier"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.projectPreLocations.locations.length > 0) ? _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Show predefined address"
    },
    on: {
      "change": _vm.fncClearAddressSelectors
    },
    model: {
      value: (_vm.projectAddressAlt),
      callback: function($$v) {
        _vm.projectAddressAlt = $$v
      },
      expression: "projectAddressAlt"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.projectAddressAlt == true) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Select Location")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectPreLocations.locations,
      "label": "Select Location",
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSetRegionSub()
      }
    },
    model: {
      value: (_vm.projectAddressAltVal),
      callback: function($$v) {
        _vm.projectAddressAltVal = $$v
      },
      expression: "projectAddressAltVal"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.projectAddressAlt == false) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Select Country")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectRegions,
      "label": "Select Country",
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSetRegionSub()
      }
    },
    model: {
      value: (_vm.delCountry),
      callback: function($$v) {
        _vm.delCountry = $$v
      },
      expression: "delCountry"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.projectRegionTypes.indexOf('province') !== -1 && _vm.projectRegionSub.length != 0 && _vm.projectAddressAlt == false) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Province")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectRegionSub,
      "label": "Select Province",
      "disabled": _vm.projectRegionSub.length == 0,
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSetRegionSubSub()
      }
    },
    model: {
      value: (_vm.delProvince),
      callback: function($$v) {
        _vm.delProvince = $$v
      },
      expression: "delProvince"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.projectRegionTypes.indexOf('district') !== -1 && _vm.projectRegionSub.length != 0 && _vm.projectAddressAlt == false) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select District")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectRegionSub,
      "label": "Select District",
      "disabled": _vm.projectRegionSub.length == 0,
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSetRegionSubSub()
      }
    },
    model: {
      value: (_vm.delDistrict),
      callback: function($$v) {
        _vm.delDistrict = $$v
      },
      expression: "delDistrict"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.projectRegionTypes.indexOf('town') !== -1 && _vm.projectRegionTown.length != 0 && _vm.projectAddressAlt == false) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Select Town")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.projectRegionTown,
      "label": "Select Town",
      "disabled": _vm.projectRegionTown.length == 0,
      "item-text": "name",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.delTown),
      callback: function($$v) {
        _vm.delTown = $$v
      },
      expression: "delTown"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Street Name")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Street Name",
      "solo": ""
    },
    model: {
      value: (_vm.delStreetName),
      callback: function($$v) {
        _vm.delStreetName = $$v
      },
      expression: "delStreetName"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [((_vm.delStreetName != '' && _vm.delCountry != '') || (_vm.delStreetName != '' && _vm.projectAddressAltVal != '')) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddAddress.apply(null, arguments)
      }
    }
  }, [_vm._v("Add Address")]) : _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success",
      "disabled": ""
    }
  }, [_vm._v("Add Address")])], 1), _vm._v(" "), (_vm.projectAddresses.length > 0) ? _c('v-data-table', {
    staticClass: "elevation-1 addressList",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.projectAddresses,
      "expand": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "90%"
          }
        }, [_vm._v(_vm._s(props.item.address_display))]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_PROJECTS') !== -1) ? _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteAddress(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete")])])]) : _vm._e()])]
      }
    }], null, false, 456149130)
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('p', [_vm._v("Select an image to upload to the project.")]), _vm._v(" "), _c('input', {
    staticClass: "fileUpload",
    attrs: {
      "type": "file",
      "id": "projectImg"
    },
    on: {
      "change": _vm.fncSetImageObj
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fileHolder"
  }, [_c('p', [_vm._v("Drag & Drop / Click to Add Files")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.fileName))])]), _vm._v(" "), _c('v-flex', {
    staticClass: " mt-4 pt-4 projectImageHolder",
    attrs: {
      "lg12": ""
    }
  }, [(this.projectImages.length == 0) ? _c('small', {
    staticClass: "pt-4 pb-4"
  }, [_vm._v("No images have been uploaded to this project")]) : _vm._e(), _vm._v(" "), _vm._l((this.projectImages), function(item, key) {
    return _c('v-flex', {
      key: key,
      staticClass: "imgHolder ml-2 mt-2",
      attrs: {
        "lg3": ""
      }
    }, [_c('img', {
      attrs: {
        "src": item.source,
        "width": "100%"
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.fncRemoveImage(key)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("remove_circle")])]), _vm._v(" "), _c('label', {
      staticClass: "blackLabel"
    }, [_vm._v("Image Caption")]), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "label": "Image Caption",
        "solo": ""
      },
      model: {
        value: (item.caption),
        callback: function($$v) {
          _vm.$set(item, "caption", $$v)
        },
        expression: "item.caption"
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('p', [_vm._v("Select which vehicles must be excluded from transport calculation for this project")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.projectVehicles), function(item, key) {
    return _c('v-flex', {
      key: key,
      attrs: {
        "lg3": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "label": item.name
      },
      model: {
        value: (item.isChecked),
        callback: function($$v) {
          _vm.$set(item, "isChecked", $$v)
        },
        expression: "item.isChecked"
      }
    })], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Project Notes")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "2",
      "multi-line": "",
      "clearable": "",
      "label": "Project Notes",
      "solo": ""
    },
    model: {
      value: (_vm.projectNotes),
      callback: function($$v) {
        _vm.projectNotes = $$v
      },
      expression: "projectNotes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Site Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "2",
      "multi-line": "",
      "clearable": "",
      "label": "Site Details",
      "solo": ""
    },
    model: {
      value: (_vm.siteDetails),
      callback: function($$v) {
        _vm.siteDetails = $$v
      },
      expression: "siteDetails"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Contact Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "2",
      "multi-line": "",
      "clearable": "",
      "label": "Contact Details",
      "solo": ""
    },
    model: {
      value: (_vm.contactDetails),
      callback: function($$v) {
        _vm.contactDetails = $$v
      },
      expression: "contactDetails"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-4 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.userEditSettings) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.userEditSettings) ? _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncCreateProject.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('small', [_vm._v("* The button will activate once all required fields have been completed")])], 1)])], 1)], 1)], 1)
},staticRenderFns: []}